<script setup lang="ts">
import { NSpace, NLayout, NLayoutSider, NMenu } from "naive-ui";
import type { Component } from "vue";
import { defineComponent, h, onMounted, ref } from "vue";
import { NIcon } from "naive-ui";
import HeaderCom from "@/components/HeaderCom.vue";
import FooterCom from "@/components/FooterCom.vue";
import Footers from "@/components/Footer.vue";
import { useAuthStore } from "@/store";
const authStore = useAuthStore();
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
import {
  MailOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  SettingOutlined,
  HomeOutlined,
  UserOutlined,
  EuroOutlined,
  InsertRowLeftOutlined,
} from "@ant-design/icons-vue";
import { getCurrentTimestamp } from "@/utils/solt/timestamp";
import { sortByMd5WithSalt } from "@/utils/solt";
import { fetchMenuData, fetchProgressList } from "@/api/apply";
console.log(authStore.userInfo);
authStore.userInfo = JSON.parse(localStorage.getItem("UserInfo"));
async function getMenu() {
  const time = await getCurrentTimestamp();
  const obj = {
    timestamp: time,
  };
  const sign = await sortByMd5WithSalt(obj);
  const res = await fetchMenuData({
    timestamp: time,
    sign: sign,
  });
  let arr = [];
  res?.data.forEach((item, index) => {
    if (item.children.length === 0) {
      delete item.children;
    }
    if (item.label === "首页") {
      item.icon = () => h(InsertRowLeftOutlined);
    } else if (item.label == "拿帐户") {
      item.icon = () => h(AppstoreOutlined);
    } else if (item.label == "管帐户") {
      item.icon = () => h(SettingOutlined);
    } else if (item.label == "管资金") {
      item.icon = () => h(EuroOutlined);
    }
    if (item.label == "企业信息") {
      // res?.data.splice(index,1)
      item.icon = () => h(InsertRowLeftOutlined);
      menuOptions1.value = [item];
    } else {
      arr.push(item);
    }
  });
  console.log("菜单列表", res?.data);
  menuOptions.value = arr;
}
onMounted(() => {
  getMenu();
});
const menuOptions = ref([
  {
    key: "index",
    icon: () => h(HomeOutlined),
    label: "首页",
    title: "index",
  },
  {
    key: "2",
    icon: () => h(AppstoreOutlined),
    label: "拿账户",
    title: "dance",
    children: [
      {
        key: "countApply",
        label: "开户申请",
        title: "countApply",
      },
      {
        key: "countProgress",
        label: "开户进度",
        title: "countProgress",
      },
    ],
  },
  {
    key: "sub2",
    icon: () => h(SettingOutlined),
    label: "管账户",
    title: "管账户",
    children: [
      {
        key: "CountList",
        label: "账户列表",
        title: "countList",
      },
      {
        key: "ChargeReport",
        label: "账户消耗报告",
        title: "chargeReport",
      },
      {
        key: "chargeProgress",
        label: "充值进度",
        title: "chargeProgress",
      },
      {
        key: "ChargeRecord",
        label: "充值记录",
        title: "chargeRecords",
      },
    ],
  },
  {
    key: "sub3",
    icon: () => h(EuroOutlined),
    label: "管资金",
    title: "管资金",
    children: [
      {
        key: "Wallet",
        label: "钱包流水",
        title: "wallet",
      },
      {
        key: "WalletProgress",
        label: "钱包充值进度",
        title: "walletProgress",
      },
      {
        key: "WalletRecords",
        label: "账单管理",
        title: "walletRecords",
      },
    ],
  },
]);
const menuOptions1 = ref([
  // {
  //   key: '33',
  //   icon: () => h(InsertRowLeftOutlined),
  //   label: '企业信息',
  //   title: 'compony',
  //   mode: "vertical",
  //   children: [
  //     {
  //         key: 'CompanyInfo',
  //         label: '企业信息',
  //         title: 'CompanyInfo',
  //     },
  //     {
  //         key: 'CompanyList',
  //         label: '企业列表',
  //         title: 'CompanyList',
  //     },
  //     {
  //       key: 'Team',
  //       label: '团队管理',
  //       title: 'Team',
  //     }
  //
  //
  //   ],
  // },
]);
const selectedKeys = ref([route.name]);
const openKeys = ref(["index", "2", "sub2", "sub3"]);

function renderIcon(icon: Component) {
  return () => h(NIcon, null, { default: () => h(icon) });
}
defineProps<{ msg: string }>();

const count = ref(0);
function jumpLogin() {
  router.push("/login");
}

function getKeys(item: any) {
  router.push(item.key);
}
</script>

<template>
  <div class="sider-bar">
    <a-button
      style="
        width: 200px;
        height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 10px;
        flex-shrink: 0;
      "
    >
      <div style="display: flex; align-items: center">
        <div
          style="
            font-size: 16px;
            width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ authStore?.userInfo?.enterprise_name }}
        </div>
      </div>
    </a-button>
    <div class="sider-menu-scroll">
      <a-menu
        v-model:openKeys="openKeys"
        v-model:selectedKeys="selectedKeys"
        style="font-size: 16px; border-inline-end: none"
        mode="inline"
        :items="menuOptions"
        @click="getKeys"
      />
    </div>
    <div class="team">
      <a-menu
        :forceSubMenuRender="true"
        v-model:openKeys="openKeys"
        v-model:selectedKeys="selectedKeys"
        style="font-size: 16px"
        mode="vertical"
        :items="menuOptions1"
        @click="getKeys"
      />
    </div>
  </div>
</template>

<style scoped>
.sider-bar {
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
  background: #f0f2f5;
}

.sider-menu-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.team {
  flex-shrink: 0;
  width: 220px;
  background: #f0f2f5;
}

.title {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 10px;
  width: 82%;
  color: #000000e0;
  font-size: 16px;
  height: 50px;
  margin: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 50px;
}

.men {
  text-align: left;
}

:where(.css-dev-only-do-not-override-19iuou).ant-menu-light {
  color: rgba(0, 0, 0, 0.88);
  background: #f0f2f5;
  text-align: left;
  font-size: 16px;
}

:global(.n-layout-scroll-container) {
  color: rgba(0, 0, 0, 0.88);
  background: #f0f2f5;
}

/deep/
  :where(.css-dev-only-do-not-override-19iuou).ant-menu-inline
  .ant-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
</style>
<style>
html,
body,
#app {
  height: 100%;
  overflow: hidden !important;
}
</style>
